// composables/useUtm.ts
export const useUtm = () => {
    const { $utm } = useNuxtApp();

    const getUtmData = () => {
        if (process.client) {
            return $utm.getData();
        }
        return null;
    };

    const clearUtmData = () => {
        if (process.client) {
            $utm.clearData();
        }
    };

    const saveUtmData = () => {
        if (process.client) {
            $utm.saveData();
        }
    };

    return {
        getUtmData,
        clearUtmData,
        saveUtmData
    };
};